import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';

export interface MetricCardProps {
  value: string | number;
  label: string;
  delta?: {
    value: string;
    direction?: 'up' | 'down' | 'neutral';
  };
  className?: string;
}

const DELTA_COLOURS = {
  up: 'text-[#059669] bg-[#ECFDF5] border-[#A7F3D0]',
  down: 'text-[#DC2626] bg-[#FEF2F2] border-[#FECACA]',
  neutral: 'text-[#5E6278] bg-[#EDEEF2] border-[#D9DBE3]',
} as const;

export function MetricCard({ value, label, delta, className }: MetricCardProps) {
  const direction = delta?.direction ?? 'neutral';

  return (
    <div
      className={cn(
        'rounded-xl border border-[#EDEEF2] bg-white p-5 shadow-[0_1px_2px_rgba(13,15,26,0.05)]',
        className,
      )}
    >
      <p className="text-2xl font-bold tracking-[-0.8px] text-[#0D0F1A]">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </p>
      <p className={cn(portalDs.caption, 'mt-1 uppercase tracking-[0.5px]')}>
        {label}
      </p>
      {delta ? (
        <span
          className={cn(
            'mt-3 inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold',
            DELTA_COLOURS[direction],
          )}
        >
          {delta.value}
        </span>
      ) : null}
    </div>
  );
}

export function MetricCardGrid({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('grid grid-cols-1 gap-3 sm:grid-cols-3', className)}>
      {children}
    </div>
  );
}
